import { render, staticRenderFns } from "./sign-form.vue?vue&type=template&id=18d03626&"
import script from "./sign-form.vue?vue&type=script&lang=js&"
export * from "./sign-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports